import { CountryEnum, CurrencyEnum } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationMessagesResource = Resources.base.market.validationMessages;

export const getMarketEditFromSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		name: z
			.string()
			.nonempty({ message: `${t(validationMessagesResource.name)}` })
			.optional()
			.nullable(),
		country: z.nativeEnum(CountryEnum).nullish(),
		currency: z.nativeEnum(CurrencyEnum).nullish(),
		webReferrer: z
			.string()
			.nonempty({ message: `${t(validationMessagesResource.webReferrer)}` })
			.optional()
			.nullable(),
		companyId: z.number().int().nullish(),
		companyBankDetailId: z.number().int().nullish(),
		timezone: z.string().nullish(),
		b2bOptions: z
			.string()
			.nullish()
			.refine(
				(val) => {
					if (!val) return true;
					try {
						const parsed = JSON.parse(val);
						return Array.isArray(parsed);
					} catch {
						return false;
					}
				},
				{ message: "Invalid JSON (expect array of { value, label })" },
			),
		isActive: z.boolean().nullish(),
	});
};

export type MarketEditFormSchema = z.infer<
	ReturnType<typeof getMarketEditFromSchema>
>;
